import { all, fork, put, takeEvery, select } from 'redux-saga/effects';
import axios from 'axios';
import {
    GET_TAGS,
    ADD_TAG,
    REMOVE_TAG,
} from '../actions';

import {
    addTagSuccess,
    addTagError,
    removeTagSuccess,
    removeTagError,
    getTagsSuccess,
    getTagsError
} from './actions';

import {
    baseURL
} from "../../constants/defaultValues";

const getToken = state => state.auth.user && state.auth.user.token ? state.auth.user.token : undefined;

/* Signup Flow */
export function* watchAddTag() {
    yield takeEvery(ADD_TAG, addTag);
}

function* addTag({ payload }) {
    const { phoneNumber,name } = payload.tag;
    // Prepare API Request Data
    const data = {
        name,
        phoneNumber,
    };
    const token = yield select(getToken);
    const headers = {
        headers: { Authorization: `${token}` }
    };
    try {
        const response = yield axios.post(`${baseURL}/tags`,data,headers);
        if (response && response.data && response.data._id) {
            // Generate Token
            yield put(addTagSuccess(response.data));
            yield put({type: GET_TAGS});
        } else {
            // Error
            const message = response && response.data && response.data.message ? response.data.message :
            "Error Creating Tag, Please verify data";
            yield put(addTagError(message));
        }

    } catch (error) {
        // Error
        const message = error.response && error.response.data && error.response.data.message ? error.response.data.message :
        "Error Getting Organization";
        yield put(addTagError(message));
    }
}

/* Signin Flow */
export function* watchGetTags() {
    yield takeEvery(GET_TAGS, getTags);
}

function* getTags() {
    const token = yield select(getToken);
    const headers = {
        headers: { Authorization: `${token}` }
    };
    try {
        // Generate Token
        const response = yield axios.get(`${baseURL}/tags`,headers);
        if (response && response.data && response.data) {
            yield put(getTagsSuccess(response.data));
        } else {
            // Error
            const message = response && response.data && response.data.message ? response.data.message :
            "Error Getting Tags, Please verify data";
            yield put(getTagsError(message));
        }
    } catch (error) {
        // Error
        const message = error.response && error.response.data && error.response.data.message ? error.response.data.message :
        "Error Getting Tags";
        yield put(getTagsError(message));
    }
}

/* OTP Flow */
export function* watchRemoveTag() {
    yield takeEvery(REMOVE_TAG, removeTag);
}

function* removeTag({ payload }) {
    const { tagId } = payload.tag;
    // Prepare API Request Data
    const data = {
        tagId
    };
    const token = yield select(getToken);
    const config = {
        headers: { Authorization: `${token}` },
        data
    };

    try {
        const response = yield axios.delete(`${baseURL}/tags`,config);
        if (response && response.data && response.data.message) {
            yield put(removeTagSuccess());
            yield put({type: GET_TAGS});
        } else {
            // Error
            const message = response && response.data && response.data.message ? response.data.message :
            "Error Signining In, Please verify data";
            yield put(removeTagError(message));
        }
    } catch (error) {
        // Error
        const message = error.response && error.response.data && error.response.data.message ? error.response.data.message :
        "Error Getting Organization";
        yield put(removeTagError(message));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchGetTags),
        fork(watchAddTag),
        fork(watchRemoveTag),
    ]);
}